import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Tourist Visa', href: '/visa-types?type=tourist' },
      { name: 'Business Visa', href: '/visa-types?type=business' },
      { name: 'Work Visa', href: '/visa-types?type=work' },
      { name: 'Student Visa', href: '/visa-types?type=student' },
    ],
    destinations: [
      { name: 'United States', href: '/countries/us' },
      { name: 'United Kingdom', href: '/countries/gb' },
      { name: 'Canada', href: '/countries/ca' },
      { name: 'Australia', href: '/countries/au' },
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'How It Works', href: '/#how-it-works' },
      { name: 'FAQs', href: '/faqs' },
      { name: 'Contact', href: '/contact' },
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Refund Policy', href: '/refund' },
    ],
  };

  return (
    <footer className="bg-[#0A1E40] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">

            {/* <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-[#FF5A36] rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">E</span>
              </div>
              <span className="font-bold text-xl" style={{ fontFamily: 'Outfit, sans-serif' }}>
                EasyMyVisa
              </span>
            </Link> */}

              <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">        
                                        <img src="/images/logo1.png" alt="EasyMyVisa Logo" className=""  style={{ width: '210px', height: '60px' }} />
                        </Link>

            <p className="text-white/70 mb-6 max-w-sm mt-2">
              Simplifying visa applications for travelers worldwide. Fast, secure, and hassle-free visa processing at your fingertips.
            </p>
            <div className="space-y-3">
              <a href="mailto:support@easymyvisa.com" className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
                info@mahantimmigration.com
              </a>
              <a href="tel:+911234567890" className="flex items-center gap-3 text-white/70 hover:text-white transition-colors">
                <Phone className="w-5 h-5" />
                +91 7041110116
              </a>
              <div className="flex items-center gap-3 text-white/70">
                <MapPin className="w-5 h-5" />
                First Floor 42-43, Bhavya Sqaure, Nr City Park, Kadi-382715, Mehsana, Gujarat, India
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif',color: 'white'  }}>Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name} >
                  <Link to={link.href} className="text-white/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif',color: 'white'  }}>Top Destinations</h4>
            <ul className="space-y-3">
              {footerLinks.destinations.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-white/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif',color: 'white'  }}>Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-white/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-sm">
            © {currentYear} MAHANT IMMIGRATION AND TOURS PVT. LTD. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="Facebook">
              <Facebook  className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="Twitter">
              <Twitter  className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
